import { ExportAllListActions } from '../ExportAllButton';
import React from 'react';
import {
  ListGuesser,
  ShowGuesser,
  CreateGuesser,
  FieldGuesser,
  InputGuesser,
  EditGuesser,
} from '@api-platform/admin';
import {
  ChipField,
  DateField,
  ReferenceField,
  TextField,
  ReferenceArrayField,
  SingleFieldList,
  SelectArrayInput,
} from 'react-admin';

export const UserList = (props) => {
  return (
    <ListGuesser actions={<ExportAllListActions />} {...props}>
      <FieldGuesser source={'email'} />
      <FieldGuesser source={'firstname'} />
      <FieldGuesser source={'lastname'} />
      <ReferenceArrayField
        label="Companies"
        reference="companies"
        source="companies"
      >
        <SingleFieldList>
          <ChipField source="name" />
        </SingleFieldList>
      </ReferenceArrayField>
      <FieldGuesser source={'active'} />
      <DateField source={'lastLogin'} locales={'de'} showTime />
    </ListGuesser>
  );
};

export const UserShow = (props) => (
  <ShowGuesser {...props}>
    <FieldGuesser source={'email'} />
    <FieldGuesser source={'firstname'} />
    <FieldGuesser source={'lastname'} />
    <FieldGuesser source={'roles'} />
    <ReferenceArrayField
      label="Companies"
      reference="companies"
      source="companies"
    >
      <SingleFieldList>
        <ChipField source="name" />
      </SingleFieldList>
    </ReferenceArrayField>
    <ReferenceArrayField label="Cities" reference="cities" source="cities">
      <SingleFieldList>
        <ChipField source="name" />
      </SingleFieldList>
    </ReferenceArrayField>
    <DateField source={'lastLogin'} locales={'de'} showTime />
    <FieldGuesser source={'active'} />
    <ReferenceField label="CreatedBy" source="createdBy.@id" reference="users">
      <TextField source="email" />
    </ReferenceField>
    <ReferenceField label="UpdatedBy" source="updatedBy.@id" reference="users">
      <TextField source="email" />
    </ReferenceField>
  </ShowGuesser>
);

export const UserCreate = (props) => (
  <CreateGuesser {...props}>
    <InputGuesser source={'email'} />
    <InputGuesser source={'firstname'} />
    <InputGuesser source={'lastname'} />
  </CreateGuesser>
);

export const UserEdit = (props) => (
  <EditGuesser {...props}>
    <InputGuesser source={'email'} />
    <InputGuesser source={'firstname'} />
    <InputGuesser source={'lastname'} />
    <SelectArrayInput
      source="roles"
      choices={[
        { id: 'ROLE_COURSE_CREATOR', name: 'ROLE_COURSE_CREATOR' },
        { id: 'ROLE_SEO_EDITOR', name: 'SEO Editor (drafts only)' },
        { id: 'ROLE_ADDER_AND_EDIT_OWN', name: 'ROLE_ADDER_AND_EDIT_OWN' },
        { id: 'ROLE_REVIEW_CODE_USER', name: 'ROLE_REVIEW_CODE_USER' },
        { id: 'ROLE_USER', name: 'ROLE_USER' },
        { id: 'ROLE_API_USER', name: 'ROLE_API_USER' },
        { id: 'ROLE_BRANCH_USER', name: 'ROLE_BRANCH_USER' },
        { id: 'ROLE_BRANCH_ADMIN', name: 'ROLE_BRANCH_ADMIN' },
        { id: 'ROLE_COMPANY_ADMIN', name: 'ROLE_COMPANY_ADMIN' },
        { id: 'ROLE_ADMIN', name: 'ROLE_ADMIN' },
      ]}
    />
    <InputGuesser source={'active'} />
  </EditGuesser>
);
